export function updateServiceCountData(id) {
    const lettersArr  = ['A', 'B', 'C', 'D'],
        namesArr  = ['Visualisation', '3d modeling', 'Product dev', 'Development'];

    const sliderData = document.querySelector('.slider-data'),
        sliderDataLetter = document.querySelector('.slider-data__letter'),
        sliderDataCount = document.querySelector('.slider-data__count'),
        sliderDataCount2 = document.querySelector('.slider-data__count-2'),
        sliderDataName = document.querySelector('.slider-data__name');

    sliderData.classList.add('hide');

    setTimeout(() => {
        sliderDataLetter.innerHTML = lettersArr[id];
        sliderDataCount.innerHTML = id + 1;
        sliderDataCount2.innerHTML = '0' + (id + 1) + '/';
        sliderDataName.innerHTML = namesArr[id];
        sliderData.classList.remove('hide');
    }, 250)
}
